import React, {useState, useEffect, useRef} from 'react';
import Popup from '../UI/Popup/Popup';
import './ToolTip.scss'

const ToolTip = ({children, tooltipText}) => {
    const [open, setOpen] = useState(false)
    const [isMobile, setIsMobile] = useState(false)
    const [popupContent, setPopupContent] = useState(null)
    const tooltipRef = useRef(null)

    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.matchMedia('(max-width: 767px)').matches);
        };
        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
                event.preventDefault()
                event.stopPropagation()
                setOpen(false)
            }
        }

        if (open) {
            document.addEventListener('mousedown', handleClickOutside)
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [open])

    const handleClick = () => {
        if (isMobile) {
            setPopupContent(tooltipText);
        } else {
            setOpen(!open);
        }
    };

    const closePopup = () => {
        setPopupContent(null);
    };

    return (
        <>
            <div className={`toolTip ${open ? 'open' : ''}`} ref={tooltipRef}>
                <div onClick={handleClick}>{children}</div>
                {!isMobile && <div className="toolTip__content">{tooltipText}</div>}
            </div>
            <Popup isOpen={!!popupContent} onClose={closePopup}>
                <p>{popupContent}</p>
            </Popup>
        </>
    )
};

export default ToolTip;
